
import React from 'react';

interface ExpenseTableHeaderProps {
  showActions: boolean;
}

const ExpenseTableHeader: React.FC<ExpenseTableHeaderProps> = ({ showActions }) => {
  return (
    <thead className="bg-purple-DEFAULT text-white sticky top-0">
      <tr>
        <th className="px-4 py-3 text-left font-medium">Description</th>
        <th className="px-4 py-3 text-left font-medium">Amount</th>
        <th className="px-4 py-3 text-left font-medium">Split</th>
        <th className="px-4 py-3 text-left font-medium">Paid By</th>
        <th className="px-4 py-3 text-left font-medium">Date</th>
        {showActions && <th className="px-4 py-3 text-left font-medium">Actions</th>}
      </tr>
    </thead>
  );
};

export default ExpenseTableHeader;
